import { SelectSearchField } from 'components'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useFormikContext } from 'formik'


const propTypes = {
  name     : PropTypes.string,
  label    : PropTypes.string,
  required : PropTypes.bool
}

const defaultProps = {
  name     : '',
  label    : '',
  required : true
}

/**
 * Search field to select payment method.
 * @param {string} name - Formik field name
 * @param {string} label - Field Label
 * @param {bool} required - It will show required badge if it set `true`
 */
const PaymentMethodSelectSearchField = ({
  name,
  label,
  required,
  userId,
  productIdWithSellingPriceList,
  ...props
}) => {

  const { setFieldError, setFieldTouched, setFieldValue } = useFormikContext()

  const paymentMethodList = [
    {
      label: "Cash",
      value: "cash",
      installment: null,
    },
    {
      label: "EDC",
      value: "edc",
      installment: null,
    },
    {
      label: "Virtual Account (Full Payment)",
      value: "virtual_account",
      installment: null,
    },
    {
      label: "Credit Cards (Full Payment)",
      value: "credit_card",
      installment: null,
    },
    // {
    //   label: "Credit Cards (Cicil 3 Bulan)",
    //   value: "credit_card",
    //   installment: 3,
    // },
    // {
    //   label: "Credit Cards (Cicil 6 Bulan)",
    //   value: "credit_card",
    //   installment: 6,
    // },
    // {
    //   label: "Credit Cards (Cicil 12 Bulan)",
    //   value: "credit_card",
    //   installment: 12,
    // },
    {
      label: "Direct Bank Transfer",
      value: "manual_transfer",
      installment: null,
    },
  ]
  const [ filteredPaymentMethodList, setFilteredPaymentMethodList ] = useState(paymentMethodList)
  const [ isSearchLoading, setSearchLoading ] = useState(false)

  // The presentation of option label when dropdown is open
  const getOptionLabel = (option) => (
    option.label
  )

  // handler to search payment methods
  const handleSelectSearchOnChange = (event) => {
    const searchText = event.target.value
    setFilteredPaymentMethodByQuery(paymentMethodList, searchText)
  }
  const setFilteredPaymentMethodByQuery = (paymentMethodList, searchText) => {
    if(searchText){
      setFilteredPaymentMethodList(
        paymentMethodList.filter(o => o.logistic.name.toLowerCase().includes(searchText) || o.rate.name.toLowerCase().includes(searchText))
      )
    }else{
      setFilteredPaymentMethodList(paymentMethodList)
    }
  }

  return (
    <SelectSearchField
      type='text'
      name={ name }
      label={ label }
      placeholder='Search payment method...'
      dataList={ filteredPaymentMethodList }
      onSearchChange={ handleSelectSearchOnChange }
      getOptionLabel={ getOptionLabel }
      isLoading={ isSearchLoading }
      required={ required }
      onSelect={(selectedOption) => {
        setFieldValue(name, selectedOption)
        setFieldTouched(name, true, false)
      }}
      { ...props }
    />
  )
}

PaymentMethodSelectSearchField.propTypes    = propTypes
PaymentMethodSelectSearchField.defaultProps = defaultProps

export default PaymentMethodSelectSearchField
